function getLocale() {
    let country = 
        getLocaleFromPath(window.location.pathname) ??
        getLocaleFromQueryParam() ??
        getLocaleFromDevice() ??
        "us"

    country = country.toLowerCase()

    if (["us", "ca"].includes(country)) {
        return country
    }

    return "us";
}

function getLocaleFromQueryParam() {
    // Get the query string from the current URL
    var queryParams = new URLSearchParams(window.location.search);
    // Extract the 'country' query parameter (default to us if missing)
    var country = queryParams.get("country") ? queryParams.get("country").toLowerCase() : null;

    return country;
}

function getLocaleFromDevice() {
    const userLocale = navigator.languages ? navigator.languages[0] : navigator.language;
    // return new Intl.Locale(userLocale).region;
    return userLocale.split('-')[1] || 'us';  // Default to 'US' if no region
}

function getLocaleFromPath(pathname) {
    const path = pathname.startsWith("/") ? pathname.slice(1) : pathname; // Remove leading "/"
    const components = path.split('/')

    var country = null;
    const firstComponent = components[0].toLowerCase()
    if (["us", "ca"].includes(firstComponent)) {
        country = components[0].toLowerCase()
    }

    return (!country) ? null : country;
}

function getTarget() {
    var queryParams = new URLSearchParams(window.location.search);
    var target = queryParams.get("target") ? queryParams.get("target").toLowerCase() : "web";

    return target;
}

function openInNewTab(url) {
    window.open(url, '_blank', 'noopener,noreferrer');
}

function isValidUrl(urlString) {
    try {
      new URL(urlString);
      return true;
    } catch (err) {
      return false;
    }
}

function isMapUrl(urlString) {
    if (isValidUrl(urlString)) {
        return urlString.includes("affected-states") || urlString.includes("nationwide")
    }

    return false
}

function isCaseCountMapUrl(urlString) {
    if (isValidUrl(urlString)) {
        return urlString.includes("case-count") || urlString.includes("cases")
    }
    
    return false
}

const getParamString = () => {
    return window.location.search;
}

const getAbsoluteHomeURL = () => {
    return window.location.hostname + window.location.search;
}

function trimString(input) {
    var inputString = input ?? "";
    
    return inputString.trim();
}

function cleanUpString(input) {
    var inputString = input ?? "";
    return inputString.replace(/[^A-Za-z0-9\s]/g, '');
}

function preprocessString(input) {
    var inputString = input ?? "";
    return cleanUpString(trimString(inputString)).toLowerCase();
}

const shareData = (dataToShare) => {
    console.log('shareData is called', dataToShare);
    //Check if the Android app has a Javascript interface first..
    if (window.NativeAndroid && window.NativeAndroid.shareData) {
        //First, you need to create a wrapper 
        //for Javascript interface to work correctly...
        let shareDataNativeAndroid = function() {
            window.NativeAndroid.shareData(JSON.stringify(dataToShare));
        };
        
        shareDataNativeAndroid(dataToShare);
    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iOSMessageHandler) {
        //Check if it's an iOS app with javascript message handlers...

        window.webkit.messageHandlers.iOSMessageHandler.postMessage({
            "dataToShare": JSON.stringify(dataToShare)
        });
    } else {
        //Fallback
        copyOrShare({
            'textToCopy': dataToShare.url,
            'alertMessage': dataToShare.fallbackAlertMessage,
        });
    }
}

const copyOrShare = (dataToShare) => {
    const textToCopy = dataToShare.textToCopy;
    const alertMessage = dataToShare.alertMessage;

    if (!textToCopy || !alertMessage) {
        console.log('Missing data in copyOrShare', dataToShare);
        return;
    }

    let tempData = {
        title: "Share",
        text: `Wanted to share this alert with you: `,
        url: textToCopy,
    }

    if (!navigator.canShare) {
        copyToClipboard(dataToShare);
    } else if (navigator.canShare(tempData)) {
        console.log("Navigator share available...")
        navigator.share( tempData );
    } else {
        console.log("Navigator share NOT available...Trying clipboard instead..")
        copyToClipboard(dataToShare);
    }
}

const copyToClipboard = (dataToShare) => {
    const textToCopy = dataToShare.textToCopy;

    navigator.clipboard.writeText(textToCopy).then( 
        v => {
            console.log("clipboard available!");
            alert('Copied to clipboard.');
        },
        e => {
            console.log("Clipboard not available. Trying Javascript interface instead..");
            if (window.NativeAndroid && window.NativeAndroid.copyToClipboard) {
                let copyToClipboard = function (copyText) {
                    window.NativeAndroid.copyToClipboard(copyText);
                }
                
                copyToClipboard(textToCopy);
                alert('Copied to clipboard.');
            } else {
                console.log("clipboard error: Trying the fallback instead.");
                copyToClipboardFallBack(dataToShare);
            }
        }
    )
}

const copyToClipboardFallBack = (dataToShare) => {
    const textToCopy = dataToShare.textToCopy;
    const alertMessage = dataToShare.alertMessage;

    if (!textToCopy || !alertMessage) {
        console.log('Missing data in copyToClipboard', dataToShare);
        return;
    }

    var copyhelper = document.createElement("input");
    copyhelper.className = 'copyhelper'
    document.body.appendChild(copyhelper);
    copyhelper.value = textToCopy;
    copyhelper.select();

    document.execCommand("copy");
    document.body.removeChild(copyhelper);

    window.alert(`${alertMessage}`);
}

export { getParamString, getAbsoluteHomeURL, shareData, trimString, 
    cleanUpString, preprocessString, isValidUrl, isMapUrl, isCaseCountMapUrl,
    getLocale, getLocaleFromQueryParam, getLocaleFromDevice, getLocaleFromPath, getTarget };
export default openInNewTab;